import { render } from "./SubHome.vue?vue&type=template&id=0d31ceec"
import script from "./SubHome.vue?vue&type=script&lang=js"
export * from "./SubHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__